import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';

import { fetchChannelAssets, fetchEntitledChannels } from './queryFunctions';
import { createChannelCollectionQueryOptions } from './queryOptions';
import { ChannelsSettings } from './settings';
import { QuerySettings } from './useChannelCollection';

type FetchChannelCollectionQueryArgs = {
  settings: ChannelsSettings;
};

export function fetchChannelCollectionQuery({ settings }: FetchChannelCollectionQueryArgs) {
  return queryClient.fetchQuery(createChannelCollectionQueryOptions(settings as QuerySettings));
}

export function prefetchChannelCollectionQuery({ settings }: FetchChannelCollectionQueryArgs) {
  return queryClient.prefetchQuery(createChannelCollectionQueryOptions(settings as QuerySettings));
}

export function fetchEntitledChannelsQuery() {
  return queryClient.fetchQuery({
    queryKey: queryKeys.entitledChannels,
    queryFn: fetchEntitledChannels,
    staleTime: Infinity,
  });
}

export function fetchChannelsQuery() {
  return queryClient.fetchQuery({
    queryKey: queryKeys.channelAssets,
    queryFn: fetchChannelAssets,
    staleTime: Infinity,
  });
}
